import React, { Component } from 'react';
import { setCookie } from '../../../../../helpers/cookie';

export default class QrPCView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sbpStatus: null
        }
    }

    componentDidMount() {
        this.fetchApiSBP();
    }

    fetchApiSBP() {
        const data = {
            'orderNumber': this.props.orderNumber
        };
        const redirectLink = this.props.redirectLink;

        const headers = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        };

        if (process.env.NODE_ENV !== 'dev') headers.credentials = 'include';

        const route = "/local/php_interface/api/v2/payment/sbp/";

        let apiTimeout = setTimeout(getStatusSBP.bind(this), 30000);
        
        function getStatusSBP() {
            fetch(route, headers)
                .then((response) => response.json())
                .then((json) => {
                    if (json.status === "success" && json.data.order_status !== "expired") {
                        if (json.data.order_status === 'paid') {
                            this.setState({sbpStatus : json.data});

                            setCookie('UNPAID_ORDER', '');
                            setCookie('PAYMENT_LINK', '');
                            setCookie('ORDER_ID', '');
                            setCookie('SBPPAY', '');
                            setCookie('PAYMENT_METHOD', '');
                            setCookie('PUSHKIN_FIO', '');

                            setTimeout(function(){
                                window.location.href = redirectLink;
                            }, 1000);

                            return;
                        }

                        apiTimeout = setTimeout(getStatusSBP.bind(this), 15000);
                    } else if (json.data.order_status === "expired") {
                        setCookie('UNPAID_ORDER', '');
                        setCookie('PAYMENT_LINK', '');
                        setCookie('ORDER_ID', '');
                        setCookie('SBPPAY', '');
                        setCookie('PAYMENT_METHOD', '');
                        setCookie('PUSHKIN_FIO', '');

                        setTimeout(function(){
                            window.location.href = '/';
                        }, 1000);
                    }
                });
        }
    }

    getImgSrc() {
        if (this.state.sbpStatus !== null) {
            return `/local/templates/comfortkino/static/img/sbp_success.svg`;
        } else {
            return `data:image/png;base64,${this.props.qr}`;
        }
    }

    render() {
        const img = this.getImgSrc();

        return (
            <div className="sbp-pay-pc_body">
                <p className="sbp-pay_hint">Для оплаты откройте камеру на смартфоне
                    и наведите на QR-код. Далее выберите
                    свой банк для оплаты билета.</p>
                <div class="sbp-pay_qr">
                    <img src={img} />
                </div>
                <p className="sbp-pay_warn"><img src='/local/templates/comfortkino/static/img/sbp-loader.svg' />
                <span>Ждем ответа от СБП<br />Пожалуйста, не закрывайте окно</span></p>
            </div>
        );
    }
}